<div class="menu mt-n4 mb-4 bg-white p-4">
  <ng-content></ng-content>
</div>
